<template>
<div class="MyBusinessList bgc padding-20 box-shadow">
    <div class="filters">
        <div class="add">
        </div>
        <div class="search">
            <el-input v-model="param.key" placeholder="请输入昵称" class="condition" clearable></el-input>
            <!--<el-select v-model="param.eventstatus" placeholder="活动状态" class="condition" clearable>-->
            <!--<el-option v-for="item in statusList" :key="item.code" :label="item.name"-->
            <!--:value="item.code"></el-option>-->
            <!--</el-select>-->
            <el-button type="primary" plain @click="handleQuery">搜索</el-button>
        </div>
    </div>
    <div class="result-list btn-operate-list">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column label="商家昵称" fixed class-name="left" min-width="296">
                <template slot-scope="scope">
                    <div class="imageText">
                        <img class="img" v-lazy="scope.row.rolehostlogourl" :alt="scope.row.rolehostname" preview="LeaderList">
                        <span>{{scope.row.rolehostname}}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="hostroletype" label="商家类型" class-name="center">
                <template slot-scope="scope">
                    <span>{{scope.row.hostroletype | hostroletype}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="rolehostname" label="联系人" class-name="center"></el-table-column>
            <el-table-column prop="linktel" label="联系电话" class-name="center"></el-table-column>
            <el-table-column prop="copycount" label="发布活动数" class-name="center"></el-table-column>
            <el-table-column prop="status" label="总收入" class-name="center">
                <template slot-scope="scope">
                    <span>￥{{scope.row.salemoney}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="100px" label-class-name="tr">
                <template slot-scope="scope">
                    <div class="tr">
                    <span class="separator-btn">
                        <el-button @click="handleDel(scope.row)" type="text" size="small">删除商家</el-button>
                    </span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <div class="page" style="margin-top: 15px; text-align: center">
            <el-pagination
                background
                @current-change="handleSizeChange"
                :current-page.sync="page.page"
                :page-size="page.pageSize"
                :pager-count="11"
                layout="prev, pager, next"
                :total="total">
            </el-pagination>
        </div>
    </div>
</div>
</template>

<script>
import Page from 'base/page/page'
import {mapGetters, mapActions} from 'vuex'
import {getProviderHostListByProvider, uploadProviderDeleteHostByProvider} from 'api/brandBusiness'
import {brandBusiness} from 'api/enumCode'
export default {
    name: 'MyBusinessList',
    data() {
        return {
            statusList: brandBusiness.eventstatus,
            eventsource: 4,
            param: {
                key: ''
            },
            page: {
                page: 1,
                pageSize: 5,
                pageCount: 0
            },
            total: 0,
            tableData: [],
        }
    },
    mounted() {
        this._getList()
    },
    methods: {
        handleDel(row) {
            this.$confirm('确认删除该商家', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {
                this._del(row)
            })
        },
        handleQuery() {
            this.page.page = 1
            this._getList()
        },
        handleSizeChange() {
            this._getList()
        },
        _del(row) {
            this.setLoading(true)
            uploadProviderDeleteHostByProvider({
                data: {
                    rolehostinnerid: row.rolehostinnerid,
                    hostroletype: row.hostroletype
                },
                success: data => {
                    this.$message.success('删除成功')
                    this.setLoading(false)
                    this._getList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getList() {
            this.setLoading(true)
            getProviderHostListByProvider({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = data.data.datalist
                    this.total = data.data.pageinfo.rowCount
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setParams'
        ])
    },
    filters: {
        hostroletype: function (value) {
            for (let i = 0; i < brandBusiness.hostroletype.length; i++) {
                if (value === brandBusiness.hostroletype[i].code) {
                    return brandBusiness.hostroletype[i].name
                }
            }
            return value
        }
    },
    watch: {},
    computed: {
        ...mapGetters(['user', 'permission', 'params', 'shop'])
    },
    components: {
        Page
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.MyBusinessList {
    .imageText{
        display: flex;
        .img{
            width: 50px;
            height: 50px;
            border-radius: 50%;
            margin-right: 10px;
        }
    }
    .el-pagination{
        margin-top: 20px;
        text-align: center;
    }
}
</style>
